<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class style="position: relative;margin-top: 30px;">
        <a-form :form="form" @submit="handleSubmit" style="width: 100%;">
          <a-button  type="primary" :style="{ margin: '5px'}" class="ui-search-action" @click="chooseCourse()">选择课程</a-button>
            <a-table
                    :columns="courseInfo.columns"
                    rowKey="id"
                    :dataSource="courseInfo.datas"
                    :loading="isloading"
                    :pagination="courseInfo.pagination"
                    @change="onChange"
                    :locale="{emptyText:'暂无数据'}"
                    size="small"
            >
              <span slot="status" slot-scope="status">
                <a-tag v-if="status==4" color="red">已移除</a-tag>
                <a-tag v-else-if="status==1" color="green">已发布</a-tag>
                <a-tag v-else-if="status==-1" color="red">未发布</a-tag>
                <a-tag v-else-if="status==2" color="red">直播中</a-tag>
                <a-tag v-else-if="status==3" color="green">已结束</a-tag>
                <a-tag v-else color="gray">已删除</a-tag>
              </span>
               <span slot="action" slot-scope="action">
                <pxkeji-btn v-if="action.is_deleted==0"
                        name="移除"
                        :roles="[]"
                        @click="remove(action.id)"
                        size="small"
                        type="dashed"
                />
                </span>
            </a-table>
<!--          <a-form-item :wrapper-col="{ span: 21, offset: 3 }">-->
<!--            <pxkeji-btn name="保存" type="primary" htmlType="submit" />-->
<!--          </a-form-item>-->
        </a-form>
      </div>
      <a-modal
              v-model="chooseCourseShow"
              :footer="false"
              destroyOnClose
              width="70%"
              :maskClosable="false"
              class="ui-modal"
      >
        <courseChoose @callbackMethod="addCourse" :ids="info.targetIds" :userId="this.id" :buyCourseIds="info.buycourseIds" />
      </a-modal>
    </div>
  </a-spin>
</template>

<script>
  import courseChoose from "./chooseCourse.vue";

  const columns = [
    {
      dataIndex: "name",
      key: "name",
      align: "center",
      title: "课程名称",
    },

    {
      dataIndex: "rootName",
      key: "rootName",
      align: "center",
      title: "课程分类",
    },
    {
      dataIndex: "presentPrice",
      key: "presentPrice",
      align: "center",
      title: "价格/元",
    },
    {
      dataIndex: "teachername",
      key: "teachername",
      align: "center",
      title: "讲师",
    },
    {
      dataIndex: "status",
      key: "status",
      align: "center",
      title: "状态",
      scopedSlots: { customRender: "status" },
    },
    {
      title: "操作",
      key: "action",
      align: "center",
      scopedSlots: { customRender: "action" },
    },
  ];
  var that;
  export default {
    name: "payCourse",
    props: {
      id: String,
    },
    data() {
      return {
        form: this.$form.createForm(this),
        courseInfo: {
          columns: columns,
          datas: [],
          pagination: {
            //分页器
            showQuickJumper: true,
            hideOnSinglePage: true,
            total: 0,
            current: 1, //页码
            defaultPageSize: 10 //页容
          }
        },
        info: {
          type: 2,
          targetIds: [],
          courseIds: "",
            buycourseIds:"",
        },
        chooseCourseShow: false, //选择课程
        isloading: false,
        loadingTip: "加载中...",
      };
    },
    components: {
      courseChoose,
    },
    mounted() {
      this.$nextTick(function () {
        that = this;
        this.getBuyCourseList();
      });
    },
    methods: {
      chooseCourse() {
        this.chooseCourseShow = true;
      },

      addCourse(ids) {
        this.chooseCourseShow = false;
        // this.info.courseIds = ids;
          this.getBuyCourseList();
      },
      typeChanged(v) {
        if (v == 2) {
          this.info.targetIds = [];
        }
      },
      getBuyCourseList() {
        this.isloading = true;
        this.$api.user.getBuyCourseList(this.courseInfo.pagination.current,this.courseInfo.pagination.defaultPageSize,this.id)
                .then((res) => {
                  this.isloading = false;
                  if (res.errorCode == this.$msg.responseCode.success) {
                    if (res.data) {
                      this.courseInfo.datas=res.data.records
                      this.courseInfo.pagination.total = Number(res.data.total);
                      // this.info = res.data.trigger;
                      this.info.targetIds = res.data.targetIds
                              ? res.data.targetIds
                              : [];
                    this.info.buycourseIds=res.data.targetIds.join(",")
                    }
                  } else {
                    this.$message.error(res.errorMsg);
                  }
                })
                .catch(() => {
                  this.isloading = false;
                });
      },
      handleSubmit() {
      },
      onChange(page) {
        //页面切换回调
        this.courseInfo.pagination.current = page.current;
        this.getBuyCourseList();
      },

      error(msg) {
        this.$error({
          title: "提示",
          content: msg == undefined ? "服务器异常" : msg,
          okText: "返回",
          centered: true,
          onOk() {
            that.$emit("callbackMethod");
          },
        });
      },
       // 2021 09 13 start
      remove(courseid) {
        var userId=this.id;
          this.$confirm({
              title: "您确定要删除此项吗?",
              okText: "确定",
              okType: "danger",
              cancelText: "我再想想",
              onOk() {
                  that.isloading = true;
                  that.$api.user
                      .removeBuyCourse(userId,courseid)
                      .then(res => {
                          that.isloading = false;
                          if (res.errorCode == that.$msg.responseCode.success) {
                              that.$message.success(res.errorMsg);
                              that.getBuyCourseList();
                          } else {
                              that.$message.error(res.errorMsg);
                          }
                      })
                      .catch(() => {
                          that.isloading = false;
                      });
              },
              onCancel() {
              }
          });
      },
      // 2021 09 13 end
    },
  };
</script>
<style>
</style>